export default __webpack_public_path__ + "static/media/lock-icon-green.025fd398.svg";